// Rishton Ka Sangeet — confetti burst + short shubh chime for match moments.
import confetti from "canvas-confetti";

// Warm marigold + rose palette
const COLORS = ["#F59E0B", "#EF4444", "#DB2777", "#F97316", "#FDE68A", "#FCA5A5"];

/**
 * Play a short "shubh" 3-note chime using WebAudio.
 * Silently no-op if user's browser blocks audio (respects gesture policies).
 */
function playChime() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    const ctx = new AC();
    // Auspicious ascending: C5 → E5 → G5 (major triad, ~1.1s total)
    const notes = [
      { f: 523.25, t: 0.00, d: 0.35 },
      { f: 659.25, t: 0.18, d: 0.35 },
      { f: 783.99, t: 0.36, d: 0.55 },
    ];
    const now = ctx.currentTime;
    notes.forEach(({ f, t, d }) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, now + t);
      g.gain.exponentialRampToValueAtTime(0.22, now + t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, now + t + d);
      o.connect(g).connect(ctx.destination);
      o.start(now + t);
      o.stop(now + t + d + 0.05);
    });
    // Auto-close context so we don't leak
    setTimeout(() => { try { ctx.close(); } catch { /* noop */ } }, 1500);
  } catch { /* noop */ }
}

/**
 * Fire a celebratory confetti + chime combo.
 * Use for "match / rishta jud gaya" style moments.
 */
export function celebrateMatch() {
  playChime();
  // Two-stage burst: left + right side, then a shower from top
  const duration = 1100;
  const end = Date.now() + duration;

  const burst = (originX) => {
    confetti({
      particleCount: 60,
      startVelocity: 45,
      spread: 70,
      angle: originX < 0.5 ? 60 : 120,
      origin: { x: originX, y: 0.7 },
      colors: COLORS,
      scalar: 1.05,
      ticks: 200,
    });
  };

  burst(0.15);
  burst(0.85);

  const shower = () => {
    if (Date.now() > end) return;
    confetti({
      particleCount: 6,
      startVelocity: 25,
      spread: 360,
      origin: { x: Math.random(), y: Math.random() * 0.3 },
      colors: COLORS,
      scalar: 0.9,
      ticks: 160,
    });
    requestAnimationFrame(shower);
  };
  requestAnimationFrame(shower);
}
